var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMustard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6647 40.8128L34.3932 33.3651C32.8698 31.9935 32.7042 29.6962 34.0231 28.2314L44.765 16.3013C46.0839 14.8366 48.3859 14.7612 49.9092 16.1328L58.1808 23.5805C59.7041 24.9521 59.8697 27.2494 58.5509 28.7142L47.809 40.6443C46.4901 42.109 44.188 42.1845 42.6647 40.8128ZM54.597 27.5572L50.4612 23.8333L42.1064 33.1123L46.2422 36.8362L54.597 27.5572Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8279 40.5095L28.8193 46.261L30.1117 47.4247L35.4127 42.8369L37.9976 45.1643L40.325 42.5794L32.5705 35.5972L30.243 38.182L32.8279 40.5095Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9872 49.9142C29.6412 47.6431 27.826 49.1075 26.1722 50.7958C25.166 51.8231 24.3457 53.0383 24.6484 54.088C25.3305 56.4535 27.3922 57.8401 27.0846 58.8275C26.777 59.8149 25.1962 59.8619 24.6484 61.0005C24.1006 62.1391 24.2984 63.7476 26.248 64.441C28.1975 65.1344 35.1156 65.2427 37.0479 64.4038C38.9801 63.5649 39.2685 62.7772 39.5998 62.1225C39.9312 61.4679 36.5097 59.8199 31.7972 60.2199C27.0846 60.6198 31.1915 58.5905 31.1915 57.3904C31.1915 56.1903 27.7178 54.3216 28.9872 49.9142Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMustard);
export default __webpack_public_path__ + "static/media/mustard.f64010829bfbdee7872759660542f3e7.svg";
export { ForwardRef as ReactComponent };